 $(document).ready(function() {
    $(".transparent_header .header-wrapper").hover(function() {
       $(".transparent_header .announcement-bar").addClass("regular_header");
    }, function() {
       $(".transparent_header .announcement-bar").removeClass("regular_header");
    });

    if ($(window).width() < 768) {
       $("body").removeClass("transparent_header");
    }
 });